import React, { useState } from "react";
import Images from "../../Component/Simage";

function HowItWorks() {
  return (
    <div className="how_it_works">
      <div className="container ai-container">
        <h1 className="title text-center fw-700 mb-3 mb-xxl-4">How it works</h1>
        <div className="how_it_works_cnts">
          <div className="item lft">
            <p className="label fw-700 mb-1 mb-2 text-center text-sm-start">Upload</p>
            <p className="value fw-400 mb-0 text-center text-sm-start">
              Users can easily upload files to the AInra Pin protocol.
            </p>

          </div>
          <div className="item cntr">
            {/* <div className="gif_src">
              <img src={Images.howItWorks} className="img-fluid " />
            </div> */}
            <div className="gif_src">
              <video autoPlay muted loop className="video_src img-fluid">
                <source src={Images.how_it_works_video} type="video/mp4" />
                {/* <source src={Images.storage_banner_bg} type="video/mp4" /> */}
              </video>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <div className="img_btm_cnt">
                <p className="label fw-700 mb-1 mb-2 text-center">
                  AInfra DePIN
                </p>
                <p className="value fw-400 mb-0 text-center">
                  Optimized routes and low-latency connections ensure reliable
                  access to your content.
                </p>
              </div>
            </div>
          </div>
          <div className="item ryt">
            <p className="label fw-700 mb-1 mb-2 text-center text-sm-end">Deliver</p>
            <p className="value fw-400 mb-0 text-center text-sm-end">
              Dynamic smart routing results in rapid IPFS content delivery.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
